// extracted by mini-css-extract-plugin
export default {"nav":"navbar-styles_nav__wP8Pv","navItem":"navbar-styles_navItem__ytzZT","textLink":"navbar-styles_textLink__knwBm"};